
const tableDescriptor = {
    model: 'table',//шаблон дескриптора
    title: 'service',
    columns: [//описание столбцов таблицы
        
        {
          title: 'date',
          translate: false,
          value: 'rt',
          dataKey: 'rt',
          filter: false,
          type: 'timestamp',
          width: '8%'
        },
        {
          title: 'event name',
          value: 'users_name',
          translate: false,
          dataKey: 'users_name',
          filter: true,
          type: 'text',
          width: '20%'
        },
        {
          title: 'type',
          value: 'type',
          translate: true,
          dataKey: 'type',
          filter: true,
          type: 'text',
          width: '10%'
        },
        {
          title: 'state',
          value: 'state',
          translate: true,
          dataKey: 'state',
          filter: true,
          type: 'text',
          width: '15%',
          actions: [
            {
              // title: 'state',
              tooltip: 'state',
              icon: 'circle',
              // color: 'green',
              emit: 'no'
            },       
          ],
        },       
        {
          title: 'object',
          value: 'name_device',
          translate: false,
          dataKey: 'name_device',
          filter: true,
          type: 'text',
          width: '20%'
        },
        {
          title: 'author',
          value: 'last_update_user',
          translate: false,
          dataKey: 'last_update_user',
          filter: true,
          type: 'text',
          width: '15%'
        },
        {
          title: 'disposition',
          value: 'name_path',
          translate: false,
          dataKey: 'name_path',
          filter: true,
          type: 'text',
          width: '30%'
        },         
        // {
        //   title: 'type',
        //   value: 'id',
        //   dataKey: 'id',
        //   filter: true,
        //   type: 'text',
        //   width: '15%'
        // },
        // {
        //   title: 'time', //название столбца
        //   value: 'time',//значение в строке, которое подтягивается в этот столбец
        //   dataKey: 'time',//значение в строке, которое подтягивается в этот столбец (для jsPDF таблицы)
        //   filter: false,//фильтровать ли значения в данной колонке (для type == 'timestamp' фильтрация применяется независимо от этого флага)
        //   type: 'timestamp',//формат данных столбца
        //   width: '10%'//ширина столбца в % от 100
        // },
        
    ],

    pageLimit: 40,//количество строк на одной странице таблицы
    page: 1,//дефолтная страница
    nextPageButton: true,//вкл/выкл пагинатор

    sortable: false,//флаг вкл/выкл сортировки таблицы по столбцам
    subscribed: true,//флаг вкл/выкл подписки строк на статусы (раскрашивает строки в цвета статусов строк)
    translate: true,//флаг вкл/выкл перевод (i18n) заголовков и значений
    toolbar: null,//добавляет дполонительный тулбар над шапкой таблицы (принимает строку как title. Это заготовка для размещения дополнительных функциональных элементов)   
    rowclick: true,//флаг определяет логику обработки click по ячейкам таблицы (true - клик на строку, false - клик на ячейку)
    removable: false,//добавляет столбец "действия" с кнопкой "удалить строку"
    resizable: false,//флаг вкл/выкл изменения размеров столбцов вручную (функционал требует допила)
    header: false,//флаг определяет позиционирование заголовков столбцов (внутри прокрутки или вне её)
    addButton: false,//добавляет кнопку "добавить" в заголовок первого столбца (используется для добавления внешних измерений в таблицу мониторинга устройства)
    activeActions: true,//вкл/выкл обработку событий "measureOff" для измерений
    hideState: [],//скрывает строки свойство state которых присутствует в массиве hideState. Принимает массив строк.
    hideValues: ['undefined'],//заменяет на '' (пустую строку) значения, приведенные в массиве hideValues. Принимает массив строк.

    filterBar: true,//флаг вкл/выкл фильтр бар

}

export default tableDescriptor